<div
  *ngIf="showBanner"
  class="fixed bottom-0 left-0 w-full bg-white dark:bg-gray-800 shadow-lg z-50 p-4 border-t border-gray-200 dark:border-gray-700"
>
  <div class="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
    <div class="text-sm text-gray-700 dark:text-gray-300 flex-1">
      <p>
        Utilizamos cookies para mejorar su experiencia en nuestro sitio web. Al navegar por este
        sitio, usted acepta el uso de cookies de acuerdo con nuestra
        <a href="/privacy-policies" class="text-primary hover:underline font-medium"
          >Política de Privacidad</a
        >.
      </p>
    </div>
    <div class="flex flex-wrap gap-2 justify-end">
      <p-button
        label="Personalizar"
        styleClass="p-button-text p-button-secondary"
        (click)="openPreferences()"
        [disabled]="loading"
      ></p-button>
      <p-button
        label="Rechazar Todo"
        styleClass="p-button-outlined p-button-danger"
        (click)="rejectAll()"
        [loading]="loading"
      ></p-button>
      <p-button
        label="Aceptar Todo"
        styleClass="p-button-primary"
        (click)="acceptAll()"
        [loading]="loading"
      ></p-button>
    </div>
  </div>
</div>

<p-dialog
  header="Preferencias de Cookies"
  [(visible)]="showPreferences"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-gray-600 dark:text-gray-400 mb-4">
      Puede personalizar sus preferencias de cookies a continuación. Las cookies esenciales son
      necesarias para el funcionamiento del sitio y no se pueden desactivar.
    </p>

    <div
      class="flex items-center justify-between p-3 border rounded-lg border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900"
    >
      <div class="flex flex-col">
        <span class="font-medium text-gray-900 dark:text-gray-100">Esenciales</span>
        <span class="text-xs text-gray-500 dark:text-gray-400"
          >Necesarias para el funcionamiento básico del sitio.</span
        >
      </div>
      <p-checkbox
        [binary]="true"
        [(ngModel)]="preferences.essential"
        [disabled]="true"
      ></p-checkbox>
    </div>

    <div
      class="flex items-center justify-between p-3 border rounded-lg border-gray-200 dark:border-gray-700"
    >
      <div class="flex flex-col">
        <span class="font-medium text-gray-900 dark:text-gray-100">Analíticas</span>
        <span class="text-xs text-gray-500 dark:text-gray-400"
          >Nos ayudan a entender cómo interactúan los visitantes con el sitio.</span
        >
      </div>
      <p-checkbox [binary]="true" [(ngModel)]="preferences.analytics"></p-checkbox>
    </div>

    <div
      class="flex items-center justify-between p-3 border rounded-lg border-gray-200 dark:border-gray-700"
    >
      <div class="flex flex-col">
        <span class="font-medium text-gray-900 dark:text-gray-100">Marketing</span>
        <span class="text-xs text-gray-500 dark:text-gray-400"
          >Utilizadas para mostrar anuncios relevantes.</span
        >
      </div>
      <p-checkbox [binary]="true" [(ngModel)]="preferences.marketing"></p-checkbox>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2 pt-4">
      <p-button
        label="Cancelar"
        styleClass="p-button-text"
        (click)="showPreferences = false"
        [disabled]="loading"
      ></p-button>
      <p-button
        label="Guardar Preferencias"
        (click)="savePreferences()"
        [loading]="loading"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
